export const getCookie = (name: string) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) {
        return parts.pop()?.split(";").shift();
    }

    return undefined;
};

export const setCookie = (
    name: string,
    value: string,
    days = 1
) => {

    if (name === "last_path") {
        document.cookie =
            `${name}=${encodeURIComponent(value)}; path=/; max-age=86400`;
    } else {
        document.cookie =
            `${name}=${encodeURIComponent(value)}; path=/; max-age=${days * 24 * 60 * 60}`;
    }
};